export default {
  "b2b.zdroj-detail.title-placeholder": "Resource",
  "b2b.zdroj-detail.message-empty": "Resource not found"
};
